module.exports = __webpack_public_path__ + "img/logo_white.17f1d51e.png";